"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React, { useRef } from "react";
import { Transition, TransitionGroup } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import classNames from "classnames";
import { AnimationDuration } from "../../../styles/Animations";
var getCurrentGap = function getCurrentGap(node) {
  if (!node.parentElement || node.parentElement.childElementCount === 1) {
    return "0px";
  }
  var rowGap = window.getComputedStyle(node.parentElement).rowGap;
  var isNumeric = !!parseInt(rowGap, 10);
  if (!isNumeric) {
    return "0px";
  }
  return rowGap;
};
export var Expandable = function Expandable(_a) {
  var _b = _a,
    children = _b.children,
    className = _b.className,
    _onEnter = _b.onEnter,
    _onEntered = _b.onEntered,
    _onExit = _b.onExit,
    expanded = _b.expanded,
    _b$element = _b.element,
    Element = _b$element === void 0 ? "div" : _b$element,
    _b$timeout = _b.timeout,
    timeout = _b$timeout === void 0 ? AnimationDuration.Medium : _b$timeout,
    rest = __objRest(_b, ["children", "className", "onEnter", "onEntered", "onExit", "expanded", "element", "timeout"]);
  var expandableElementRef = useRef(null);
  return /* @__PURE__ */React.createElement(TransitionGroup, {
    component: null,
    timeout: timeout
  }, expanded && /* @__PURE__ */React.createElement(Transition, __spreadValues({
    timeout: timeout,
    onEnter: function onEnter(node, isAppearing) {
      node.style.height = "0px";
      node.style.setProperty("--expandable-gap-size", getCurrentGap(node));
      forceReflow(node);
      _onEnter == null ? void 0 : _onEnter(node, isAppearing);
      requestAnimationFrame(function () {
        var _a2;
        node.style.height = "".concat((_a2 = expandableElementRef.current) == null ? void 0 : _a2.offsetHeight, "px");
      });
    },
    onEntered: function onEntered(node, isAppearing) {
      forceReflow(node);
      _onEntered == null ? void 0 : _onEntered(node, isAppearing);
      requestAnimationFrame(function () {
        node.style.height = "auto";
        node.style.setProperty("--expandable-gap-size", null);
      });
    },
    onExit: function onExit(node) {
      var _a2;
      node.style.height = "".concat((_a2 = expandableElementRef.current) == null ? void 0 : _a2.offsetHeight, "px");
      node.style.setProperty("--expandable-gap-size", getCurrentGap(node));
      forceReflow(node);
      _onExit == null ? void 0 : _onExit(node);
      requestAnimationFrame(function () {
        node.style.height = "0px";
      });
    }
  }, rest), function (status) {
    return /* @__PURE__ */React.createElement(Element, {
      className: classNames("kl-expandable", "kl-expandable--".concat(status), className, _defineProperty({}, "".concat(className, "--").concat(status), className)),
      style: {
        "--duration": "".concat(timeout, "ms")
      }
    }, children({
      status: status,
      expandableElementRef: expandableElementRef
    }));
  }));
};